import { readVarT } from '@execonline-inc/environment';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { SharedInvitationResource } from '../../../SharedOpenEnrollment/SharedInvitationResourceStore/Types';
import { IntercomGuestInitData } from './Types';

interface Props {
  sharedInvitation: SharedInvitationResource;
}

function intercomString(value: string): string {
  const MAX_LENGTH = 252; // 255 - 3 for ellipsis
  return value.length > MAX_LENGTH ? `${value.slice(0, MAX_LENGTH)}...` : value;
}

function IntercomSignInTooling({ sharedInvitation }: Props) {
  useEffect(() => {
    const invitation = sharedInvitation.payload;

    // Get the collection name from the Maybe<AlreadyTranslatedText>
    const collectionName = invitation.name.map((text) => text.text).getOrElseValue('');

    // Build collection and program family context from invitation
    let dpCollection = `${invitation.useCaseId}::${collectionName}`;
    let dpProgramFamily = '';

    if (invitation.kind === 'use-cases-program-family') {
      // Format program family: {programFamilyId}::{Program Family Name}
      const programFamilyName = invitation.name.map((text) => text.text).getOrElseValue('');
      dpProgramFamily = intercomString(`${invitation.programFamilyId}::${programFamilyName}`);
    }

    // Initialize Intercom for guest users with custom attributes
    readVarT('VITE_INTERCOM_APP_ID')
      .map<IntercomGuestInitData>((appId) => ({
        app_id: appId,
        'DP Collection In-View': dpCollection,
        'DP Program In-View': dpProgramFamily,
        'Organization ID': String(invitation.organization.payload.id),
        'Organization Name': String(invitation.organization.payload.name),
      }))
      .fork(() => {
        console.warn('Unable to load Intercom: Missing environment variable VITE_INTERCOM_APP_ID');
      }, Intercom);

    // Cleanup on unmount
    return shutdown;
  }, [sharedInvitation]);

  return <></>;
}

export default observer(IntercomSignInTooling);
